import React from "react"
import {useTheme} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"
import {
    SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA,
    SEARCH_DATA_GA,
    SEARCH_PREVIOUS_SEARCH_DATA_GA,
} from "../../../../../../config/constants"
import {
    ClearButton,
    ClearButtonDesktop,
    ClearButtonDesktopWrapper,
    HeaderContainer,
    HeaderWrapper,
    Title,
} from "../../../components"
import GridContent from "../../../components/GridContent"
import RecentSearchesContent from "../../../components/RecentSearchesContent"
import RecentSearches from "../../../../../../components/RecentSearches"
import {useMediaQuery} from "../../../../../../hooks/useMediaQuery"
import {StyledGridWrapper, ContentContainerStyled} from "./components"
import {Container} from "../../components"

type HeaderProps = {
    clear: () => void
    text: any
    showClearAll: boolean
}

const clrBtnTestid = "header-recent-searches-clear-button"

const Header = ({clear, text, showClearAll}: HeaderProps) => {
    const {mobileHeader, desktopHeader, clearAllButton} = text
    const theme = useTheme()
    const isMedUp = useMediaQuery(`(min-width: ${breakpoints.values.md}px)`)

    return (
        <HeaderContainer className="recents-header" data-testid="recents-header">
            <HeaderWrapper>
                <Title variant="h4">{isMedUp ? desktopHeader : mobileHeader}</Title>
                {showClearAll && !isMedUp && (
                    <ClearButton
                        data-testid={`${clrBtnTestid}-drawer`}
                        onClick={clear}
                        data-ga-v1={SEARCH_DATA_GA}
                        data-ga-v2={SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA}
                        data-ga-v3={SEARCH_PREVIOUS_SEARCH_DATA_GA}
                    >
                        {clearAllButton}
                    </ClearButton>
                )}
            </HeaderWrapper>
        </HeaderContainer>
    )
}

export type RecentSearchesProps = {
    clear: () => void
    text: any
    showClearAll: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const Content = (props: RecentSearchesProps) => {
    return (
        <Container data-testid="header-enrich-recent-searches">
            <GridContent>
                <ContentContainerStyled isNoResults isRecentSearches showSelectionHighlight={false}>
                    <Header {...props} />
                    <StyledGridWrapper isRecentSearches showSelectionHighlight={false}>
                        <RecentSearchesContent testid="recents-body">
                            <RecentSearches />
                        </RecentSearchesContent>
                    </StyledGridWrapper>
                </ContentContainerStyled>
                <ClearButtonDesktopWrapper>
                    {props.showClearAll && (
                        <ClearButtonDesktop
                            data-testid={clrBtnTestid}
                            onClick={props.clear}
                            data-ga-v1={SEARCH_DATA_GA}
                            data-ga-v2={SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA}
                            data-ga-v3={SEARCH_PREVIOUS_SEARCH_DATA_GA}
                        >
                            {props.text.clearAllButton}
                        </ClearButtonDesktop>
                    )}
                </ClearButtonDesktopWrapper>
            </GridContent>
        </Container>
    )
}

const DefaultRecentSearches = (props: RecentSearchesProps) => {
    return <Content {...props} />
}

export default DefaultRecentSearches
